enum MedicalSchool {
  CUHK = 1,
  HKU = 2,
  Others = 3
}

enum CompletionStatus {
  Saved = 0,
  Released = 10,
  Submitted = 20,
  Endorsed = 50,
  Completed = 90
}

enum Status {
  Saved = 0,
  Released = 11,
  Submitted = 21,
  ReSubmitted = 22,
  Endorsed = 51,
  Approved = 95,
  Rejected = 96
}

enum ActionType {
  Created = 0,
  Released = 11,
  Submitted = 21,
  ReSubmitted = 22,
  Endorsed = 51,
  Approved = 95,
  Rejected = 96
}

enum UploadType {
  BankinSlip = 1
}

export const basicTrainingEnums = {
  MedicalSchool,
  CompletionStatus,
  Status,
  UploadType,
  ActionType
}
